(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[165],{

/***/ 3152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-details",
      function () {
        return __webpack_require__(8717);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeaturedFAQSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75);
/* harmony import */ var styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5__);






function FeaturedFAQSection() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), question1Active = ref[0], setQuestion1Active = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), question2Active = ref1[0], setQuestion2Active = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), question3Active = ref2[0], setQuestion3Active = ref2[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_section_bg_vector),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    src: "/images/help_details/featured_faq_bg_vector.png",
                    alt: "Bg",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_section_container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('heading_1', (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_section_title)),
                        children: "Featured FAQs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_area),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_question), question1Active && (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                onClick: function() {
                                    return setQuestion1Active(!question1Active);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('heading_3', (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_question_content)),
                                        children: "How to create multiple Outings"
                                    }),
                                    question1Active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        alt: "Arrow Active",
                                        src: "/images/help_details/arrow_active.png",
                                        width: 14.73,
                                        height: 8.36
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        alt: "Arrow",
                                        src: "/images/help_details/arrow.png",
                                        width: 14.73,
                                        height: 8.36
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('description_small', (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_answer), !question1Active && (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide)),
                                children: "Whether you’re in the office or working online, we have team building games for you! From truly competitive to silly fun, group up with anyone in your team to conquer these engaging games."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_question), question2Active && (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('heading_3', (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_question_content)),
                                        onClick: function() {
                                            return setQuestion2Active(!question2Active);
                                        },
                                        children: "Receiving your team Outing details via email"
                                    }),
                                    question2Active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        alt: "Arrow Active",
                                        src: "/images/help_details/arrow_active.png",
                                        width: 14.73,
                                        height: 8.36
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        alt: "Arrow",
                                        src: "/images/help_details/arrow.png",
                                        width: 14.73,
                                        height: 8.36
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('description_small', (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_answer), !question2Active && (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide)),
                                children: "If you enter your email when creating the Outing, you’ll get a special “edit” link that you can use anytime to edit the outing."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_question), question3Active && (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                onClick: function() {
                                    return setQuestion3Active(!question3Active);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('heading_3', (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_question_content)),
                                        children: "Team Games Pricing"
                                    }),
                                    question3Active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        alt: "Arrow Active",
                                        src: "/images/help_details/arrow_active.png",
                                        width: 14.73,
                                        height: 8.36
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        alt: "Arrow",
                                        src: "/images/help_details/arrow.png",
                                        width: 14.73,
                                        height: 8.36
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('description_small', (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_answer), !question3Active && (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide)),
                                children: "Enjoy Team Games for free while we're in beta!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().featured_faq_buttons),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                href: "/contact-us",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "large_btn button_big",
                                        children: "Contact Us"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                href: "/blog/faq",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "large_btn button_big",
                                        children: "Learn More"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 6780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HelpDetailsMasthead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(369);
/* harmony import */ var styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75);
/* harmony import */ var styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5__);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HelpDetailsMasthead(param) {
    var query = param.query;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isMobile = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_4__/* .useViewport */ .Sj)().isMobile;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(query), queryInput = ref[0], setQueryInput = ref[1];
    var resetSearchQuery = function() {
        router.push({
            pathname: '/help-details/search',
            query: _objectSpread({
            }, queryInput && {
                q: queryInput
            })
        });
    };
    var handleSubmitQueryInput = function(e) {
        if (e.key === 'Enter') {
            resetSearchQuery();
        }
    };
    var handleChangeQueryInput = function(e) {
        setQueryInput(e.target.value || '');
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_bg),
                children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_bg_img),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        src: "/images/help_details/background_mobile.png",
                        alt: "Game for Every Team",
                        layout: "fill"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_bg_img),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        src: "/images/help_details/background.png",
                        alt: "Game for Every Team",
                        layout: "fill"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_left),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: 'hero ' + (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_title),
                                children: "Team Games Help"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_search_container),
                                children: [
                                    !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_search_icon),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/help_details/search_icon.png",
                                            alt: "Search Icon",
                                            width: 17,
                                            height: 17,
                                            onClick: resetSearchQuery
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_search_border)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_search_input),
                                        placeholder: "Search FAQ, Announcements, etc...",
                                        onKeyDown: handleSubmitQueryInput,
                                        value: queryInput,
                                        onChange: handleChangeQueryInput
                                    }),
                                    isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_search_icon_mobile),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            src: "/images/help_details/search_icon_mobile.png",
                                            alt: "Search Icon",
                                            layout: "fill",
                                            onClick: resetSearchQuery
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: 'description_small ' + (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_desc),
                                children: "From how to create a team Outing to pricing information, find all answers and tips here!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_right),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_help_details_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_right_image_container),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: "/images/help_details/header.png",
                                alt: "Header",
                                layout: "fill"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HelpDetailsMetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3135);



function HelpDetailsMetaTags() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "Find Help and Details for Team Games"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/images/modal_logo.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .TeamGamesMetaDescription */ .iO
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:image",
                content: utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .TeamGamesOGImagePath */ .Od
            })
        ]
    }));
};


/***/ }),

/***/ 8717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ help_details; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
// EXTERNAL MODULE: ./src/components/app_header.tsx
var app_header = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/components/app_footer.tsx
var app_footer = __webpack_require__(2695);
// EXTERNAL MODULE: ./src/components/help_details/shared/meta_tags.tsx
var meta_tags = __webpack_require__(983);
// EXTERNAL MODULE: ./src/components/help_details/shared/masthead.tsx
var masthead = __webpack_require__(6780);
// EXTERNAL MODULE: ./src/components/help_details/shared/featured_faqs.tsx
var featured_faqs = __webpack_require__(7046);
// EXTERNAL MODULE: ./src/components/modals/modal_message.tsx
var modal_message = __webpack_require__(3913);
// EXTERNAL MODULE: ./src/components/modals/modal_join_outing.tsx
var modal_join_outing = __webpack_require__(8049);
// EXTERNAL MODULE: ./src/styles/help_details.module.scss
var help_details_module = __webpack_require__(75);
var help_details_module_default = /*#__PURE__*/__webpack_require__.n(help_details_module);
;// CONCATENATED MODULE: ./src/components/help_details/featured_cards_page.tsx











var FeaturedCardsPage = function() {
    var goToListingPage = function(tag) {
        location.href = "".concat(constants/* wpRoutePrefix */._e, "/").concat(tag);
    };
    var goToFaqPage = function(slug, param) {
        var id = param === void 0 ? '' : param;
        location.href = constants/* wpRoutePrefix */._e + (id ? '/faq/' + slug + '#' + id : '/faq/' + slug);
    };
    var goToZoomMarketplace = function() {
        window.open('https://marketplace.zoom.us/apps/lVVV3EvrQoibUofep5JT-w', '_blank');
    };
    var featuredCards = [
        {
            key: 'announcements',
            onClick: function() {
                return goToListingPage('announcement');
            },
            imageSrc: '/images/help_details/announcement.png',
            imageAlt: 'Announcements',
            title: 'Announcements',
            description: 'Find out what we have coming up, and all news related to Team Games!'
        },
        {
            key: 'inviting-teams',
            onClick: function() {
                return goToFaqPage('how-to-create-a-team-outing', 'invite-your-team');
            },
            imageSrc: '/images/help_details/inviting_teams.png',
            imageAlt: 'Inviting Teams',
            title: 'Inviting Teams',
            description: 'Learn how to share your Outing details with your team'
        },
        {
            key: 'release-notes',
            onClick: function() {
                return goToListingPage('release-notes');
            },
            imageSrc: '/images/help_details/release_notes.png',
            imageAlt: 'Release Notes',
            title: 'Release Notes',
            description: 'What’s new and what’s changed with each update'
        },
        {
            key: 'our-games',
            onClick: function() {
                return goToListingPage('all-games');
            },
            imageSrc: '/images/help_details/our_games.png',
            imageAlt: 'Our Games',
            title: 'Our Games',
            description: 'Find detailed FAQs on every game currently offered by Team Games for your Outings'
        },
        {
            key: 'scheduling',
            onClick: function() {
                return goToFaqPage('how-to-create-a-team-outing', 'schedule-the-outing');
            },
            imageSrc: '/images/help_details/scheduling.png',
            imageAlt: 'Scheduling',
            title: 'Scheduling',
            description: 'Everything you need to know when scheduling your next team Outing'
        },
        {
            key: 'teamgames',
            onClick: goToZoomMarketplace,
            imageSrc: '/images/help_details/teamgames.png',
            imageAlt: 'Team Games on Zoom',
            title: 'Team Games on Zoom',
            description: 'Add the Team Games app to Zoom to enjoy the Team Games experince in your meetings'
        },
        {
            key: 'general-faq',
            onClick: function() {
                return goToListingPage('faq');
            },
            imageSrc: '/images/help_details/faq.png',
            imageAlt: 'General FAQ',
            title: 'General FAQ',
            description: 'FAQs on how to use Team Games for beginners to pros'
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (help_details_module_default()).container,
        id: "help_details_page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags/* default */.Z, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(app_header/* default */.Z, {
                transparent: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(masthead/* default */.Z, {
                query: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (help_details_module_default()).card_grid_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (help_details_module_default()).card_grid_wrapper,
                    children: featuredCards.map(function(card) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: (help_details_module_default()).card_grid_item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (help_details_module_default()).card,
                                onClick: card.onClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (help_details_module_default()).card_bg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: card.imageSrc,
                                                alt: card.imageAlt,
                                                layout: "fill",
                                                objectFit: "contain"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (help_details_module_default()).card_info,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: 'heading_2 ' + (help_details_module_default()).card_title,
                                                children: card.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: 'description_small ' + (help_details_module_default()).card_desc,
                                                children: card.description
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, card.key);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(featured_faqs/* default */.Z, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_message/* default */.Z, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_join_outing/* default */.Z, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(app_footer/* default */.Z, {
            })
        ]
    }));
};
/* harmony default export */ var featured_cards_page = (FeaturedCardsPage);

;// CONCATENATED MODULE: ./src/pages/help-details/index.tsx

/* harmony default export */ var help_details = (featured_cards_page);


/***/ }),

/***/ 75:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"help_details_loading_container__3Qvpb","header_section":"help_details_header_section__VFGAw","header_bg":"help_details_header_bg__uEkWN","header_bg_img":"help_details_header_bg_img__b68SB","header_container":"help_details_header_container__kiikd","header_left":"help_details_header_left__eCgG1","header_title":"help_details_header_title__Uhvyc","header_search_container":"help_details_header_search_container__mQOix","header_search_icon":"help_details_header_search_icon__J39t_","header_search_border":"help_details_header_search_border__6fsG1","header_search_input":"help_details_header_search_input__D9zNJ","header_desc":"help_details_header_desc__FnkH0","header_right":"help_details_header_right__IuwyX","header_right_image_container":"help_details_header_right_image_container__95cbW","search_section":"help_details_search_section__I8kVb","search_query":"help_details_search_query__hgZs4","search_result_container":"help_details_search_result_container__zso_X","search_result_card":"help_details_search_result_card__8u6Yo","search_result_card_more":"help_details_search_result_card_more__UrHJL","search_result_card_title":"help_details_search_result_card_title__Fx1iH","search_result_card_desc":"help_details_search_result_card_desc__HgTWB","search_result_card_btn":"help_details_search_result_card_btn___jLPr","search_result_card_bg":"help_details_search_result_card_bg__Uctvu","search_result_card_date":"help_details_search_result_card_date__Ug1Rl","search_result_card_tag":"help_details_search_result_card_tag__5aHGT","search_result_pagination":"help_details_search_result_pagination__BFpJZ","pagination_btn":"help_details_pagination_btn__pAREe","card_grid_wrapper":"help_details_card_grid_wrapper__kelZl","card_grid_item":"help_details_card_grid_item__PuJ6w","card":"help_details_card__Q5wTn","card_bg":"help_details_card_bg__pxXlr","card_info":"help_details_card_info__0OBwP","card_title":"help_details_card_title__Afs_u","card_desc":"help_details_card_desc__jDQ_G","card_grid_section":"help_details_card_grid_section__mzgKa","featured_faq_section":"help_details_featured_faq_section__r1Syu","featured_faq_section_bg_vector":"help_details_featured_faq_section_bg_vector__4Yosk","featured_faq_section_container":"help_details_featured_faq_section_container__gZqBk","featured_faq_section_title":"help_details_featured_faq_section_title__D6Hgg","featured_faq_area":"help_details_featured_faq_area__Z5ol9","featured_faq_question":"help_details_featured_faq_question__Mj8zi","featured_faq_question_content":"help_details_featured_faq_question_content__B_Ie9","active":"help_details_active__Xfcy0","featured_faq_answer":"help_details_featured_faq_answer__Ux1KM","hide":"help_details_hide__fOXOO","featured_faq_buttons":"help_details_featured_faq_buttons__OyLF9","header_search_icon_mobile":"help_details_header_search_icon_mobile__mZtUc"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [78,673,680,774,888,179], function() { return __webpack_exec__(3152); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);